import React from "react";
import {
  ShoppingBag,
  Camera,
  Wallet,
  CheckCircle2,
  Sparkles,
  ShieldCheck,
} from "lucide-react";
import Productslideshow from "../../components/Productslideshow";


export default function SunscreenBarterCollaboration() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-sky-50 via-white to-pink-50">

      {/* Hero Section */}
      <section className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid lg:grid-cols-2 gap-14 items-center">

          {/* Left */}
          <div>

            <div className="inline-flex items-center gap-2 rounded-full bg-pink-100 px-4 py-2 text-pink-600 font-semibold">
              <Sparkles size={16} />
              Influencer Campaign
            </div>

            <h1 className="mt-3 md:mt-6 text-4xl md:text-5xl lg:text-6xl font-black leading-tight text-gray-900">
              Shinzura
              <span className="text-sky-600"> Sunscreen</span>
              <br />
              Barter Collaboration
            </h1>

            <p className="mt-3 md:mt-6 text-lg text-gray-600 leading-8">
              We have recently launched our new{" "}
              <span className="font-bold text-sky-600">
                Sun Freeze SPF 50 PA++++ Sunscreen
              </span>
              .
              Join our influencer campaign, create amazing content, and get
              <span className="font-bold text-pink-600">
                {" "}
                100% refund
              </span>{" "}
              after your videos are approved.
            </p>
            <div className="mt-10 flex flex-wrap gap-4">
                <a
                    href="https://wa.me/917665363669?text=Hey%2C%20I%20am%20interested%20in%20the%20Shinzura%20Sunscreen%20Barter%20Collaboration."
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-white text-green-600 px-8 py-4 rounded-xl font-bold text-lg hover:scale-105 transition flex items-center gap-2 border-2"
                >
                    💬 Join on WhatsApp
                </a>
            </div>

          </div>

          {/* Right */}

          <div className="relative flex justify-center">

            <div className="absolute inset-0 blur-3xl bg-sky-300 opacity-30 rounded-full"></div>

            <img
              src="/Product_imgs/sunscreen-50ml/1.png"
              alt="Shinzura Sunscreen"
              className="relative w-[360px] lg:w-[430px] drop-shadow-2xl"
            />

          </div>

        </div>
      </section>

      {/* Steps */}

      <section className="max-w-7xl mx-auto px-6 py-10">

        <div className="text-center">

          <h2 className="text-4xl font-bold">
            How It Works
          </h2>

          <p className="text-gray-600 mt-2">
            Complete 4 simple steps and receive your full refund.
          </p>

        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-8 mt-14">

          <div className="bg-white rounded-xl md:rounded-3xl p-3 md:p-8 shadow hover:shadow-xl transition">
            <ShoppingBag className="text-sky-600 mb-2" size={32} />
            <h3 className="font-bold text-base md:text-xl">
              1. Order Products
            </h3>
            <p className="mt-1 text-gray-600">
              Order one or multiple Shinzura products using our Flipkart links.
            </p>
          </div>

          <div className="bg-white rounded-xl md:rounded-3xl p-3 md:p-8 shadow hover:shadow-xl transition">
            <ShieldCheck className="text-pink-500 mb-2" size={32} />
            <h3 className="font-bold text-base md:text-xl">
              2. Send Screenshot
            </h3>
            <p className="mt-3 text-gray-600">
              Share your Flipkart order confirmation screenshot with our team.
            </p>
          </div>

          <div className="bg-white rounded-xl md:rounded-3xl p-3 md:p-8 shadow hover:shadow-xl transition">
            <Camera className="text-sky-600 mb-2" size={32} />
            <h3 className="font-bold text-base md:text-xl">
              3. Create Videos
            </h3>
            <p className="mt-3 text-gray-600">
              Make one high-quality video for every product you receive.
            </p>
          </div>

          <div className="bg-white rounded-xl md:rounded-3xl p-3 md:p-8 shadow hover:shadow-xl transition">
            <Wallet className="text-green-500 mb-2" size={32} />
            <h3 className="font-bold text-base md:text-xl">
              4. Get Refund
            </h3>
            <p className="mt-3 text-gray-600">
              Once your videos are approved, we'll refund your complete order amount.
            </p>
          </div>

        </div>

      </section>

      {/* Campaign Rules */}

      <section className="bg-white py-10">

        <div className="max-w-6xl mx-auto px-6">

          <div className="text-center mb-8 md:mb-10">

            <h2 className="text-3xl md:text-4xl font-bold">
              Campaign Guidelines
            </h2>

            <p className="text-gray-600 mt-3">
              Please read the following rules before placing your order.
            </p>

          </div>

          <div className="grid md:grid-cols-2 gap-1">

            {[
              "Order only through the Flipkart links shared by our team.",
              "You may order multiple products in one order.",
              "One video is mandatory for every product ordered.",
              "Videos should be original and not previously uploaded.",
              "Refund will be processed only after content approval.",
              "Campaign is valid from 1 July to 15 August.",
              "Please keep the product packaging until approval.",
              "Refund will be credited to your original payment method.",
            ].map((rule, index) => (
              <div
                key={index}
                className="flex gap-4 rounded-2xl bg-sky-50 p-2"
              >
                <CheckCircle2 className="text-green-500 mt-1 flex-shrink-0" />
                <p className="text-gray-700">
                  {rule}
                </p>
              </div>
            ))}

          </div>

        </div>

      </section>

      {/* Footer CTA */}

      <section className="bg-pink-600 from-sky-600 to-pink-600 py-10">

        <div className="max-w-4xl mx-auto text-center px-6 text-white">

          <h2 className="text-5xl font-black">
            Interested in Collaborating ?
          </h2>

          <p className="mt-6 text-xl text-white/90">
            If you'd like to be a part of our <strong>Shinzura Sunscreen Barter Collaboration</strong>,
      simply click the <strong>WhatsApp</strong> button below. Our team will share the Flipkart
      product links and guide you through the entire process.
          </p>

          <div className="mt-10 flex justify-center">
                <a
                    href="https://wa.me/917665363669?text=Hey%2C%20I%20am%20interested%20in%20the%20Shinzura%20Sunscreen%20Barter%20Collaboration."
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-white text-green-600 px-8 py-4 rounded-xl font-bold text-lg hover:scale-105 transition flex items-center gap-2"
                >
                    💬 Join on WhatsApp
                </a>
            </div>


        </div>
      </section>
      <div className="container mx-auto mt-8">
            <Productslideshow showproduct={'sun-freeze-sunscreen-spf-50-pa++++'}/>
        </div>

    </div>
  );
}